export const CREATE_TARGET = "CREATE_TARGET";
export const DELETE_TARGET = "DELETE_TARGET";
export const CREATE_NONTARGET = "CREATE_TARGET";
export const DELETE_NONTARGET = "DELETE_TARGET";
export const UPDATE_GENOME = "UPDATE_GENOME";
export const CREATE_SUPERSELECTOR = "CREATE_SUPERSELECTOR";
export const DELETE_SUPERSELECTOR = "DELETE_SUPERSELECTOR";
